const getters = {
  sidebar: state => state.system.sidebar,
  terminalType: state => state.system.terminalType,
  chioseRouter: state => state.system.chioseRouter,
  loginState: state => state.system.isLogin,
  select:state=>state.select,
  fullScreen:state=>state.system.fullScreen,
  userInfo:state=>state.system.userInfo,
  searchIconEvent:state=>state.system.searchIconEvent,

  userBaseInfo:state=>state.userBaseInfo.info,
  mobile:state=>state.userBaseInfo.mobile,
  datacount:state=>state.userBaseInfo.datacount,
  adressList:state=>state.userBaseInfo.adressList
};
export default getters;
